import type { RouteObject } from "react-router";

import React from "react";
import { createBrowserRouter, Navigate } from "react-router";

import { AuthenticationProvider } from "@/auth";
import FeatureOverrideDevTool from "@/components/dev-tools/feature-override/FeatureOverrideDevTool";
import Admin from "@/pages/Admin";
import Home from "@/pages/Home";
import { LoggedOut } from "@/pages/LoggedOut";

import { AdminRoutes } from "./AdminRoutes";
import { RouteErrorFallback } from "./RouteErrorFallback";

const routes = [
    {
        path: "/admin",
        element: (
            <AuthenticationProvider>
                <AdminRoutes />
            </AuthenticationProvider>
        ),
        children: [
            {
                path: "/admin",
                element: <Admin />,
            },
        ],
    },
    {
        path: "/logged-out",
        element: <LoggedOut />,
    },
    {
        path: "/",
        element: (
            <AuthenticationProvider>
                <Home />
                <FeatureOverrideDevTool />
            </AuthenticationProvider>
        ),
    },
    {
        path: "*",
        element: <Navigate to="/" replace />,
    },
] satisfies RouteObject[];

if (import.meta.env.DEV) {
    const ContactCenterDemo = React.lazy(() => import("./ContactCenterDemo"));

    routes.push({
        path: "/contact-center-demo",
        element: (
            <AuthenticationProvider>
                <ContactCenterDemo />
            </AuthenticationProvider>
        ),
    });
}

export const router = createBrowserRouter([{ errorElement: <RouteErrorFallback />, children: routes }]);
